var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"r-divider",class:{ vertical: _vm.vertical }})
}
var staticRenderFns = []

export { render, staticRenderFns }